import { render, staticRenderFns } from "./evaStudent.vue?vue&type=template&id=1b13f5bc&scoped=true&"
import script from "./evaStudent.vue?vue&type=script&lang=js&"
export * from "./evaStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b13f5bc",
  null
  
)

export default component.exports